import { render, staticRenderFns } from "./buy-card-word.vue?vue&type=template&id=89d2d826&scoped=true&lang=pug&"
import script from "./buy-card-word.vue?vue&type=script&lang=js&"
export * from "./buy-card-word.vue?vue&type=script&lang=js&"
import style0 from "./buy-card-word.vue?vue&type=style&index=0&id=89d2d826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d2d826",
  null
  
)

export default component.exports